var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperclipAttechmentTilt = function SvgPaperclipAttechmentTilt(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53516 11.4647L11.4294 4.5704C13.4797 2.52015 16.8039 2.52015 18.8541 4.5704C20.9044 6.62066 20.9041 9.94496 18.8539 11.9952L10.8989 19.9502C9.53209 21.317 7.31639 21.3168 5.94955 19.95C4.58272 18.5831 4.58238 16.3673 5.94922 15.0005L13.9042 7.0455C14.5876 6.36208 15.6962 6.36208 16.3796 7.0455C17.0631 7.72892 17.0626 8.83669 16.3792 9.52011L9.48486 16.4144",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclipAttechmentTilt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Paperclip_Attechment_Tilt.2c5c0601.svg";
export { ForwardRef as ReactComponent };